import { render, staticRenderFns } from "./valuable-concepts-modal-grid-basic-form.vue?vue&type=template&id=1c411299&"
import script from "./valuable-concepts-modal-grid-basic-form.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-grid-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports